import dTS1 from './tests/delugeTestData/testSetOne';
import NITD from './tests/nestedInheritenceTestData/dataSet';

function addLevels(scene, levels, mergeType = 'partial') {
  const templates = copy(dTS1.templates);
  const spinnyCubeTemplate = templates['6d91620e-e732-4226-a8c2-2b93f98bc3bc'];
  const template = copy(NITD.templateOne);

  const nodeUID = template.uid;
  const nodeSvars = template.src_scene_data;

  const finalNodeUID = spinnyCubeTemplate.uid;
  const finalNodeSvars = spinnyCubeTemplate.src_scene_data;

  const portName = '$MyOnlyPort';

  if (mergeType !== 'partial') {
    throw new Error(
      'mergeType must be partial, anything else is not supported yet.'
    );
  }

  // Partial emulates what scene data looks like before it is 'merged', ie, direct from the DB
  if (mergeType === 'partial') {
    const keysToKeep = ['scene_data', 'type', 'value'];
    const nukeObjArray = [nodeSvars, finalNodeSvars];

    for (const obj of nukeObjArray) {
      for (const value of Object.values(obj)) {
        for (const key of Object.keys(value)) {
          if (!keysToKeep.includes(key)) {
            delete value[key];
          }
        }
      }
    }
  }

  let nextNode = scene.svars;

  for (let i = 1; i <= levels; i++) {
    Object.assign(nextNode, copy(nodeSvars));
    nextNode[portName]['value'] = nodeUID;
    nextNode[portName]['scene_data'] = {};

    if (i !== levels) {
      nextNode = nextNode[portName]['scene_data'];
    } else {
      nextNode[portName]['value'] = finalNodeUID;
      nextNode[portName]['scene_data'] = copy(finalNodeSvars);
    }
  }
}

function navigateLevels(svars, depthToGoto, port) {
  for (let i = 1; i <= depthToGoto; i++) {
    svars = svars[port]['scene_data'];
  }

  return svars;
}

function sortOrder(a, b, keyOrder) {
  const first = keyOrder.indexOf(a);
  const second = keyOrder.indexOf(b);

  if (first < second) {
    return -1;
  } else if (first > second) {
    return 1;
  }
  return 0;
}

function sortNested(merge, thisTemplate, templates) {
  // Default key order for nested

  let subKeyOrder = [
    'name',
    'label',
    'description',
    'keyInherited',
    'mode',
    'asset_tag_filter',
    'init',
    'port_index',
    'flag',
    'flagType',
    'type',
    'value',
    'scene_data',
  ];

  for (const nextNode of Object.values(merge)) {
    const newSubObj = {};

    const sorted = Object.keys(nextNode).sort((a, b) =>
      sortOrder(a, b, subKeyOrder)
    );

    // Create a new object with the sorted keys
    for (const key of sorted) {
      newSubObj[key] = nextNode[key];
    }

    // Clear the original object and assign the new sorted object
    Object.keys(nextNode).forEach((key) => delete nextNode[key]);
    Object.assign(nextNode, newSubObj);

    if (nextNode.scene_data) {
      const nextTemplate = templates && templates[nextNode.value];
      sortNested(nextNode.scene_data, nextTemplate, templates);
    }
  }

  // sort the top level keys
  if (!thisTemplate?.src_scene_data) {
    console.warn(
      'No src_scene_data found in thisTemplate. Cannot sort top level keys.'
    );
    return merge;
  }
  let sourceData = thisTemplate.src_scene_data;
  if (thisTemplate.extra_info?.preset && thisTemplate.extra_info.src_template) {
    sourceData = templates[thisTemplate.extra_info.src_template].src_scene_data;
  }

  if (thisTemplate) {
    const tempObj = {};
    for (const key in sourceData) tempObj[key] = merge[key];

    // delete all the current keys in the merge object
    for (const key in merge) delete merge[key];

    // Copy the temp object into the merge object
    Object.assign(merge, tempObj);
  }

  return merge;
}

function copy(obj) {
  return JSON.parse(JSON.stringify(obj));
}
export default {
  addLevels,
  copy,
  navigateLevels,
  sortNested,
  sortOrder,
};
